import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type { InitiateResolutionPayload } from '~/api/resolution-engine/types/InitiateResolution.types'

export const useInitiateResolutionApi = (body: InitiateResolutionPayload) => {
  const $httpFetch = useHttpFetch()

  return $httpFetch('/resolution-engine/resolutions', {
    method: 'POST',
    body,
  })
}
